import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import "./SlotPicker.css";
import moment from "moment";
import Button from "../Button/Button";
import {SlotPickerDefault} from '../../../shared/constants';
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import MediaQuery from 'react-responsive';


/**
 * @desc SlotPicker
 * @param props
 * @return null
 */


    const SlotPicker = (props) => {
        const { className,duration, isAmPm, currentSelectedDate, ...other } = props;
        var dateArr = [];
        var fullDateArr = []; 
        let currentSelectedDateFormatDate = currentSelectedDate.getDate();
        if(currentSelectedDate.getDate() < 10){
            currentSelectedDateFormatDate = "0"+(currentSelectedDate.getDate());
        }
        let currentSelectedDateFormatMonth = currentSelectedDate.getMonth()+1;
        if((currentSelectedDate.getMonth()+1) < 10 ){
            currentSelectedDateFormatMonth = "0"+(currentSelectedDate.getMonth()+1);
        }
        let currentSelectedDateFormat = (currentSelectedDateFormatDate)+"-" + (currentSelectedDateFormatMonth) + "-" + currentSelectedDate.getFullYear();

        if(isAmPm == "am"){
            var fromDate = moment(SlotPickerDefault.startTime, "hmm");
            const durationValue = duration ==="30 mins" ? 0.5 : duration.split(' ')[0];
            for(let i=0;i<=11;i++) {
                dateArr.push(moment(fromDate).format("hh:mm")  + " - " + moment(fromDate).add(durationValue, 'hours').format("hh:mm"));
                fromDate = moment(fromDate).add(0.25, 'hours');
            }
        }else{
            var fromDate = moment("1200", "hmm");
            const durationValue = duration === "30 mins" ? 0.5 : duration.split(' ')[0];
            const hours = Math.floor(SlotPickerDefault.endTime/100);
            const minutes = SlotPickerDefault.endTime%100;
            const loopTimes = ((hours*60)/15) + (minutes/15);
            for(let i=0;i<=loopTimes;i++) {
                dateArr.push(moment(fromDate).format("hh:mm")  + " - " + moment(fromDate).add(durationValue, 'hours').format("hh:mm"));
                fromDate = moment(fromDate).add(0.25, 'hours');
            }
        }

        var fromDate1 = moment(SlotPickerDefault.startTime, "hmm");
        const durationValue1 = duration ==="30 mins" ? 0.5 : duration.split(' ')[0];
        for(let i=0;i<=11;i++) {
            fullDateArr.push(moment(fromDate1).format("HH:mm")  + " - " + moment(fromDate1).add(durationValue1, 'hours').format("HH:mm"));
            fromDate1 = moment(fromDate1).add(0.25, 'hours');
        }
        
        var fromDate2 = moment("1200", "hmm");
        const durationValue2 = duration === "30 mins" ? 0.5 : duration.split(' ')[0];
        const hours = Math.floor(SlotPickerDefault.endTime/100);
        const minutes = SlotPickerDefault.endTime%100;
        const loopTimes = ((hours*60)/15) + (minutes/15);
        for(let i=0;i<=loopTimes;i++) {
            fullDateArr.push(moment(fromDate2).format("HH:mm")  + " - " + moment(fromDate2).add(durationValue2, 'hours').format("HH:mm"));
            fromDate2 = moment(fromDate2).add(0.25, 'hours');
        }

        return(
            <div className={"ui-slotpicker " + className}>
                {dateArr.map((date)=> {

                    let splitTime = date.split(" - ");
                    let currentStartTime = splitTime[0];
                    let currentEndTime = splitTime[1];

                    let startTimeDetails = currentStartTime.split(':');
                    let startTimeHour = startTimeDetails[0];
                    let startTimeMinute = startTimeDetails[1];

                    let endTimeDetails = currentEndTime.split(':');
                    let endTimeHour = endTimeDetails[0];
                    let endTimeMinute  = endTimeDetails[1];
                    let updatedDate = date;

                    if(isAmPm === 'pm'){
                        if(startTimeDetails[0] !== '12'){
                            startTimeHour = parseInt(startTimeDetails[0]) + 12;
                            endTimeHour = parseInt(endTimeDetails[0]) + 12;
                        }

                        if(endTimeDetails[0] !== '12'){
                            endTimeHour = parseInt(endTimeDetails[0]) + 12;
                        }

                        updatedDate = startTimeHour+":"+startTimeMinute+ " - "+endTimeHour+":"+endTimeMinute;
                    }else{
                        if(parseInt(endTimeDetails[0]) < 9){
                            endTimeHour = parseInt(endTimeDetails[0]) + 12;
                        }
                        updatedDate = startTimeHour+":"+startTimeMinute+ " - "+endTimeHour+":"+endTimeMinute;

                    }

                    let overLapClass =" ";
                    if(props.overlappingSlots){
                        props.overlappingSlots.map((overlap) => { 
                            if((overlap.time === date) || (overlap.time === updatedDate)){
                                if(overlap.forSlotDate == currentSelectedDateFormat){
                                    overLapClass = "overlapped";
                                }
                            }
                        })
                    }

                    const slotClass = props.selectedSlots.some(item => item.slot === date & (item.date.getDate() +"-" + parseInt(item.date.getMonth()+1) + "-" + item.date.getFullYear()) === props.currentSelectedDate.getDate() +"-" + parseInt(props.currentSelectedDate.getMonth()+1) + "-" + props.currentSelectedDate.getFullYear()) ? "Selected" : 'Select';  
                    return (
                        <Fragment>
                            <Button className={"slot-select " + slotClass +" "+ overLapClass} onClick={(e)=>{
                                e.preventDefault();
                                if(overLapClass !== 'overlapped'){
                                    props.timeSelect(date,isAmPm,props.currentSelectedDate,dateArr,fullDateArr)
                                }
                                } } >
                                <div className={"slot-time "+ slotClass}>{date}</div>
                            </Button>
                        </Fragment>
                    )
                })
                }
            </div>
        );
    }
  
    SlotPicker.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    duration:PropTypes.number,
    selectedSlots:PropTypes.Array,
    };

    SlotPicker.defaultProps = {
    className: "",
    label: "",
    value: "",
    duration:3,
    selectedSlots:[]
    };

    export default SlotPicker;


// WEBPACK FOOTER //
// ./src/components/UI/SlotPicker/SlotPicker.js